import * as React from "react";
import { CategoryDetailResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { useState } from "react";

export type CategoryDescriptionItem = {
  category: CategoryDetailResult;
};

export const CategoryDescription = ({
  category,
}: CategoryDescriptionItem): JSX.Element => {
  let [showMore, setShowMore] = useState(false);
  return (
    <>
      {category.description.shortHtml !== null ? (
        <div id="category-description">
          <div
            dangerouslySetInnerHTML={{
              __html: category.description.shortHtml,
            }}
          />

          {category.description.fullHtml !== null ? (
            <>
              <div
                className={`full-description ${showMore ? "active" : ""}`}
                dangerouslySetInnerHTML={{
                  __html: category.description.fullHtml,
                }}
              />
              <div className={"show-more-container"}>
                <a
                  className="show-more-btn"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? "Zpět" : "Více"}
                </a>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};
